import { Col, Container, Row } from 'react-bootstrap';
import ContentBlock from '../../Components/contentBlock/ContentBlock';
import { SimpleAncer } from '../../Components/button';
import CustomSelect2 from '../../Components/customSelect2/CustomSelect2';
import CustomInput from '../../Components/customInput/CustomInput';
import LoginBgTwo from './LoginBgTwo';
import { HeadingDescVsmall } from '../../Components/Headings';
import './fewMoreDetail.css';
import i18n from '../../i18n';

const city = [
  { value: 'karachi', label: 'Karachi' },
  { value: 'hederabad', label: 'Hederabad' },
  { value: 'lahore', label: 'Lahore' },
  { value: 'islamabad', label: 'Islamabad' }
];

const gender = [
  { value: 'male', label: 'Male' },
  { value: 'female', label: 'Female' }
];

const date = [
  { value: '1', label: '1' },
  { value: '2', label: '2' },
  { value: '3', label: '3' },
  { value: '4', label: '4' },
  { value: '5', label: '5' }
];

const month = [
  { value: 'jan', label: 'Jan' },
  { value: 'feb', label: 'Feb' },
  { value: 'march', label: 'March' },
  { value: 'april', label: 'April' },
  { value: 'may', label: 'May' }
];

const year = [
  { value: '2003', label: '2003' },
  { value: '2004', label: '2004' }
];

function FewMoreDetail() {
  return (
    <LoginBgTwo>
      <div className="fewMoreDetail">
        <Container>
          <Row>
            <Col md={6} />
            <Col md={6}>
              <div className="content">
                <Row>
                  <Col md={12}>
                    <div className="content_container">
                      <ContentBlock
                        heading={i18n.t('we_are_almost')}
                        body={i18n.t('just_details')}
                      />
                      <form className="form">
                        <HeadingDescVsmall text={i18n.t('city')} />
                        <CustomSelect2 options={city} placeholder="" />
                        <HeadingDescVsmall text={i18n.t('gender')} />
                        <CustomSelect2 options={gender} placeholder="" />
                        <Row>
                          <Col md={6}>
                            <HeadingDescVsmall text={i18n.t('height_ft')} />
                            <div className="sizeContainer">
                              <CustomInput type="text" placeholder="FT" />
                              <CustomInput type="text" placeholder="IN" />
                            </div>
                          </Col>
                          <Col md={6}>
                            <HeadingDescVsmall text={i18n.t('weight_kg')} />
                            <CustomInput type="text" />
                          </Col>
                        </Row>
                        <HeadingDescVsmall text={i18n.t('date_birth')} />
                        <div className="dateOfBirth">
                          <div>
                            <CustomSelect2 placeholder="DD" options={date} />
                          </div>
                          <div>
                            <CustomSelect2 placeholder="MM" options={month} />
                          </div>
                          <div>
                            <CustomSelect2 placeholder="YYYY" options={year} />
                          </div>
                        </div>
                        <div className="btns_container">
                          <SimpleAncer
                            to="/accountCreated"
                            text={i18n.t('continue')}
                          />
                        </div>
                      </form>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </LoginBgTwo>
  );
}

export default FewMoreDetail;
